import * as yup from 'yup';
import { Box, Button, Grid } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import { ReferClient } from '../../api';
import { useAppDispatch, useAppSelector } from '../../store';
import { referClientAsync } from '../../store/adviser';
import FormikWrapper from '../containers/FormikWrapper';
import { Colors, DialogBox, HelpTooltip, SectionTitleText, TitleText } from '../controls/helpers';
import CheckboxList from '../controls/inputs/CheckboxList';

const clientReferralSchema: yup.SchemaOf<ReferClient> = yup.object({
    firstName: yup.string(),
    lastName: yup.string(),
    email: yup.string(),
    opportunityTypes: yup.array().required('Required').min(1, 'Please select at least one product'),
    mobile: yup.string()
});

const Refer = ({ cancel, ok, open, firstName, lastName, email, mobile }: {
    cancel: () => void; 
    ok: () => void;
    open: boolean;
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
}) => {
    const { isSubmitting } = useAppSelector(state => state.adviser);
    const dispatch = useAppDispatch();
    return <DialogBox icon={<CheckCircleIcon htmlColor={Colors.Green} />} open={open} isSubmitting={isSubmitting}>
        <FormikWrapper
            initialValues={{ opportunityTypes: [] as string[], firstName, lastName, email, mobile }}
            validationSchema={clientReferralSchema}
            onSubmit={values => {
                dispatch(referClientAsync(values));
                ok();
            }}>
            {({ setFieldValue, values }) => <>
                <TitleText hideMarginBottom>Invitation sent successfully.</TitleText>
                <SectionTitleText hideBorderBottom>
                    Other opportunities to help?&nbsp;
                    <HelpTooltip title="Refer to NZ Funds and we will make a payment to your business under our referral programme if the client proceeds." />
                </SectionTitleText>
                <Box pb={2}>
                    <CheckboxList
                        label="Check if your client has:"
                        name="opportunityTypes"
                        setFieldValue={setFieldValue}
                        values={values.opportunityTypes}
                        options={[
                            { label: 'KiwiSaver', value: 'KiwiSaver' },
                            { label: 'Wealth Builder', value: 'Wealth Builder' },
                            { label: 'Lump Sum', value: 'Lump Sum' },
                            { label: 'UK Pension Transfer', value: 'UK Pension Transfer' },
                            { label: 'Australian Superannuation Transfer', value: 'Australian Pension Transfer' }
                        ]}
                    />
                    <p>I confirm the client has authorised me to provide this information to NZ Funds.</p>
                </Box>
                <Grid container justifyContent="space-between">
                    <Button variant="contained" type="button" startIcon={<CloseIcon />} onClick={cancel} disabled={isSubmitting}>Skip</Button>
                    <Button variant="contained" type="submit" color="primary" disabled={isSubmitting}>Refer</Button>
                </Grid>
            </>}
        </FormikWrapper>
    </DialogBox>
}

export default Refer;
